import {getStep, getServiceStep} from '../services/workflow';
import {actions as progressActions} from './progress';

export const actions = {
  FETCH_PENDING: 'STEP::FETCH_PENDING',
  FETCH_FULFILLED: 'STEP::FETCH_FULFILLED',
  FETCH_REJECTED: 'STEP::FETCH_REJECTED',
  CHANGE: 'STEP::CHANGE',
  NEXT: 'STEP::NEXT',
  PREVIOUS: 'STEP::PREVIOUS',
  DYNAMIC_SELECTION: 'STEP::DYNAMIC_SELECTION',
  REPLACE_DYNAMIC_QUESTIONS: 'STEP::REPLACE_DYNAMIC_QUESTIONS',
};

export function fetchStep(stepHandle, inputHandle, inputValue) {
  return dispatch => {
    dispatch({type: actions.FETCH_PENDING});

    return getStep(stepHandle, inputHandle, inputValue)
      .then(step => {
        if (step.complete) {
          dispatch({type: progressActions.COMPLETED_STEPS});
        } else {
          dispatch({
            type: actions.DYNAMIC_SELECTION,
            payload: {stepHandle},
          });
          dispatch({type: actions.FETCH_FULFILLED, payload: {step}});
        }

        return step;
      })
      .catch(err => {
        dispatch({
          type: actions.FETCH_REJECTED,
          payload: {
            error: {
              title: 'Unable to fetch step',
              message: err.message,
            },
          },
        });
      });
  };
}

export function fetchService(serviceHandle) {
  return dispatch => {
    dispatch({type: actions.FETCH_PENDING});

    return getServiceStep(serviceHandle)
      .then(step => {
        dispatch({type: progressActions.COMPLETE_SERVICE_SELECTION});
        dispatch({type: actions.FETCH_FULFILLED, payload: {step}});
        scrollToTop();

        return step;
      })
      .catch(err => {
        dispatch({
          type: actions.FETCH_REJECTED,
          payload: {
            error: {
              title: 'Unable to fetch service',
              message: err.message,
            },
          },
        });
      });
  };
}

export function previousStep() {
  scrollToTop();

  return {
    type: actions.PREVIOUS,
  };
}

export function nextStep() {
  scrollToTop();

  return {
    type: actions.NEXT,
  };
}

export function changeStep(index) {
  return {
    type: actions.CHANGE,
    payload: {
      index,
    },
  };
}

export function loadStep(step) {
  return {
    type: actions.FETCH_FULFILLED,
    payload: {
      step,
    },
  };
}

/**
 * After a dynamic question has been fetched we need to
 * dispatch this action to manage cleaning up the old
 * question references, and adding the new question references
 * according to the current selection.
 *
 * @param {string} stepHandle
 * @param {string} questionHandle
 * @param {string[]} newQuestionHandles
 * @returns {object}
 */
export function replaceDynamicQuestions(
  stepHandle,
  questionHandle,
  newQuestionHandles = []
) {
  return {
    type: actions.REPLACE_DYNAMIC_QUESTIONS,
    payload: {
      stepHandle,
      questionHandle,
      newQuestionHandles,
    },
  };
}

/**
 * When navigating between steps we want to scroll to the top
 */
function scrollToTop() {
  document.documentElement.scrollTop = 0;
}
